import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IndexComponent } from './index/index.component';
import {rentalRouting} from "./rental.routing";



@NgModule({
  declarations: [
    IndexComponent
  ],
  imports: [
    CommonModule,
    rentalRouting
  ]
})
export class RentalModule { }
